<template>
  <section :class="['row', 'row--inverted', {'row--slidup': isInView}]">
    <header class="row__header">
      <h2 class="row__title row__title--small">
        Caredo usprawnia działalność
      </h2>
    </header>
    <ul class="feats">
      <li class="feats__feat">
        <div class="feats__content">
          <img class="feats__icon" :src="require('@/assets/img/icon-building.svg')">
          <h3 class="feats__name">
            Salonów dealerskich
          </h3>
        </div>
      </li>
      <li class="feats__feat">
        <div class="feats__content">
          <img class="feats__icon" :src="require('@/assets/img/icon-cog.svg')">
          <h3 class="feats__name">
            Serwisów samochodowych
          </h3>
        </div>
      </li>
      <li class="feats__feat">
        <div class="feats__content">
          <img class="feats__icon" :src="require('@/assets/img/icon-key.svg')">
          <h3 class="feats__name">
            Wypożyczalni aut
          </h3>
        </div>
      </li>
      <li class="feats__feat">
        <div class="feats__content">
          <img class="feats__icon" :src="require('@/assets/img/icon-list.svg')">
          <h3 class="feats__name">
            Organizacji zarządzających flotami
          </h3>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'features',
};
</script>

<style lang="scss" scoped>
.feats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 36px;
  list-style: none;
  justify-content: center;
  margin: 80px auto 0;
  max-width: 1088px;
  padding: 0;
  width: 90vw;

  @media screen and (min-width: 1920px) {
    margin: 80px auto 0;
  }

  @media screen and (max-width: 1400px) {
    grid-template-columns: repeat(auto-fill, 245px);
  }

  @media screen and (max-width: 768px) {
    margin: 80px 40px 0;
  }
}

.feats__feat {
  background-color: $bg-tertiary;
  box-shadow: 0px 0px 6px $shadow;
  padding-top: 100%;
  position: relative;
}

.feats__content {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  left: 0;
  padding: 20% 10% 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.feats__icon {
  margin-bottom: 18%;
  width: 60px;
}

.feats__name {
  font-size: 1.125em;
  margin: 0;
}
</style>
